import { UseInteractionsReturn } from '@floating-ui/react'
import { createContext, useContext } from 'react'
import { TSizeAll } from 'src/types'

export interface ComboboxContextValue {
  activeIndex: number | null
  selectedIndexes: number[]
  getItemProps?: UseInteractionsReturn['getItemProps']
  handleSelect: (index: number) => void
  setSearchTerm: (value: string) => void
  searchTerm: string
  size: TSizeAll
  allowMultiple: boolean
  showSearch: boolean
}

export const ComboboxContext = createContext<ComboboxContextValue | null>(null)

export const useComboboxContext = () => {
  const context = useContext(ComboboxContext)
  if (!context) {
    throw new Error('useComboboxContext must be used within a ComboboxContextProvider')
  }
  return context
}
